// Name of the cookie this app uses to remember the visitor's chosen language.
// Owned entirely by this app - do not reuse a name that any other RHP site/host
// (e.g. RHP.Public.SS) reads or writes, or that app's own culture negotiation can
// silently overwrite this one whenever the visitor hits a page it serves on the
// same domain.
export const CULTURE_COOKIE_NAME = 'AffiliateQuarter.Culture';

// Query string key this app's language dropdown appends to its links (e.g.
// "?lang=fr-FR") so a fresh page load can pick up the choice immediately, before
// the cookie write from the previous click has had a chance to matter.
export const CULTURE_QUERY_KEY = 'lang';

// Google Translate language codes this app supports, derived from the culture's
// primary subtag (e.g. "en-GB" -> "en").
export const SUPPORTED_LANGS = ['en', 'es', 'de', 'nl', 'it', 'fr', 'pt', 'th', 'id', 'vi'];

export const DEFAULT_LANG = 'en';
